import { getLogger } from '../base/logging/functions';
/**
 * toolbox 模块日志。
 */
export default getLogger('features:toolbox');
